import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol8PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL8;
}

export default Atol8PoiTileEntity;
